export default __webpack_public_path__ + "under-construction.gif";